import React from 'react';
import { graphql } from 'gatsby';
import Img from 'gatsby-image';
import Slide from 'react-reveal/Slide';

import SEO from '../components/seo.js';

import { Menu, ItemWithImage } from '../styles/styles.js';

const Porcoes = ({ data }) => {
  return (
    <>
      <SEO
        title="Porções"
        keywords={[
          `Porções`,
          `Batata`,
          `Batata com Bacon`,
          `filé de frango`,
          `Porção de Calabresa`,
        ]}
      />
      <Menu className="menu">
        <Slide left cascade>
          <h1 className="menu-title">Porções</h1>
        </Slide>

        <ItemWithImage>
          <div className="item-image">
            <Img
              fluid={data.batata.childImageSharp.fluid}
              alt="Porção de Batata Cremosa"
            />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Porção de Batata</h4>

              <div className="item-price-wrapper">
                <h4 className="item-price">25,00</h4>
              </div>
            </div>
            <p className="item-desc">
              Inteira<span> 25,00</span> / Meia <span>15,00</span>
            </p>
          </div>
        </ItemWithImage>

        <ItemWithImage>
          <div className="item-image">
            <Img
              fluid={data.batatabacon.childImageSharp.fluid}
              alt="Porção de Batata com Bacon"
            />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Porção de Batata com Bacon</h4>

              <div className="item-price-wrapper">
                <h4 className="item-price">30,00</h4>
              </div>
            </div>
            <p className="item-desc">
              Inteira<span> 30,00</span> / Meia <span>20,00</span>
            </p>
          </div>
        </ItemWithImage>

        <ItemWithImage>
          <div className="item-image">
            <Img
              fluid={data.cremosa.childImageSharp.fluid}
              alt="Porção de Batata Cremosa"
            />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Porção de Batata Cremosa</h4>

              <div className="item-price-wrapper">
                <h4 className="item-price">45,00</h4>
              </div>
            </div>
            <p className="item-desc">
              Batata com mussarela, bacon e catupiry. <br />
              <br /> Inteira
              <span> 45,00</span> / Meia <span>40,00</span>
            </p>
          </div>
        </ItemWithImage>

        <ItemWithImage>
          <div className="item-image">
            <Img
              fluid={data.pastel.childImageSharp.fluid}
              alt="Porção de Mini Pastéis"
            />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Porção de Mini Pastéis</h4>

              <div className="item-price-wrapper">
                <h4 className="item-price">35,00</h4>
              </div>
            </div>
          </div>
        </ItemWithImage>

        <ItemWithImage>
          <div className="item-image">
            <Img
              fluid={data.torresminho.childImageSharp.fluid}
              alt="Panqueca"
            />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Porção de Torresminho</h4>

              <div className="item-price-wrapper">
                <h4 className="item-price">30,00</h4>
              </div>
            </div>
            {/* <p className="item-desc">Batata com mussarela, bacon e catupiry.</p> */}
          </div>
        </ItemWithImage>

        <ItemWithImage>
          <div className="item-image">
            <Img
              fluid={data.frangopassarinho.childImageSharp.fluid}
              alt="Panqueca"
            />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Porção de Frango a Passarinho</h4>

              <div className="item-price-wrapper">
                <h4 className="item-price">40,00</h4>
              </div>
            </div>
            <p className="item-desc">
              Coxinha da asa. <br />
              <br /> Inteira
              <span> 40,00</span> / Meia <span>25,00</span>
            </p>
          </div>
        </ItemWithImage>

        <ItemWithImage>
          <div className="item-image">
            <Img
              fluid={data.filefrango.childImageSharp.fluid}
              alt="Filé a Frango"
            />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Porção de Filé de Frango</h4>

              <div className="item-price-wrapper">
                <h4 className="item-price">50,00</h4>
              </div>
            </div>
            <p className="item-desc">
              Inteira
              <span> 50,00</span> / Meia <span>25,00</span>
            </p>
          </div>
        </ItemWithImage>

        <ItemWithImage>
          <div className="item-image">
            <Img fluid={data.calabresa.childImageSharp.fluid} alt="Panqueca" />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Porção de Calabresa Acebolada</h4>

              <div className="item-price-wrapper">
                <h4 className="item-price">45,00</h4>
              </div>
            </div>
            {/* <p className="item-desc">
            Promoção de porção de calabresa para o mês de setembro
          </p> */}
          </div>
        </ItemWithImage>

        <ItemWithImage>
          <div className="item-image">
            <Img fluid={data.file.childImageSharp.fluid} alt="Panqueca" />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Porção de Filé Acebolado</h4>

              {/* <p className="item-desc">
            Molho de tomate, queijo, tomate, bacon cebola e azeitona.
          </p> */}

              <div className="item-price-wrapper">
                <h4 className="item-price">70,00</h4>
              </div>
            </div>
          </div>
        </ItemWithImage>

        <ItemWithImage>
          <div className="item-image">
            <Img fluid={data.tilapia.childImageSharp.fluid} alt="Panqueca" />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Porção de Filé de Tilápia</h4>

              {/* <p className="item-desc">
            Molho de tomate, queijo, tomate, bacon cebola e azeitona.
          </p> */}

              <div className="item-price-wrapper">
                <h4 className="item-price">70,00</h4>
              </div>
            </div>
          </div>
        </ItemWithImage>

        <ItemWithImage>
          <div className="item-image">
            <Img fluid={data.frios.childImageSharp.fluid} alt="Panqueca" />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Porção de Frios</h4>

              <div className="item-price-wrapper">
                <h4 className="item-price">60,00</h4>
              </div>
            </div>
            <p className="item-desc">
              Ovo de codorna, azeitona, presunto, palmito, pepino, mussarela e
              salame.
            </p>
          </div>
        </ItemWithImage>

        <ItemWithImage>
          <div className="item-image">
            <Img fluid={data.uniao.childImageSharp.fluid} alt="Panqueca" />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Porção Especial União</h4>

              <div className="item-price-wrapper">
                <h4 className="item-price">95,00</h4>
              </div>
            </div>
            <p className="item-desc">
              Frios, calabresa, batata frita e filé de carne.
            </p>
          </div>
        </ItemWithImage>
      </Menu>
    </>
  );
};

export const query = graphql`
  query {
    batata: file(relativePath: { eq: "porcao-batata.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    batatabacon: file(relativePath: { eq: "porcao-batata-bacon.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    pastel: file(relativePath: { eq: "porcao-pastel.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    calabresa: file(relativePath: { eq: "porcao-calabresa.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    cremosa: file(relativePath: { eq: "porcao-cremosa.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    torresminho: file(relativePath: { eq: "porcao-torresminho.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    file: file(relativePath: { eq: "porcao-file.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    frangopassarinho: file(
      relativePath: { eq: "porcao-frango-passarinho.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    filefrango: file(relativePath: { eq: "porcao-file-de-frango.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    frios: file(relativePath: { eq: "porcao-frios.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    tilapia: file(relativePath: { eq: "porcao-tilapia.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    uniao: file(relativePath: { eq: "porcao-uniao.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

export default Porcoes;
